// Shared constants + badge styling for the Task Manager module
export const TASK_STATUSES = [
  { value: "pending", label: "Pending", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  { value: "todo", label: "To do", cls: "bg-zinc-100 text-zinc-700 border-zinc-200" },
  { value: "in_progress", label: "In progress", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  { value: "blocked", label: "Blocked", cls: "bg-red-50 text-red-700 border-red-200" },
  { value: "done", label: "Done", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { value: "cancelled", label: "Cancelled", cls: "bg-zinc-50 text-zinc-400 border-zinc-200" },
];

export const TICKET_STATUSES = [
  { value: "open", label: "Open", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  { value: "in_progress", label: "In progress", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  { value: "waiting_on_client", label: "Waiting on client", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  { value: "resolved", label: "Resolved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { value: "closed", label: "Closed", cls: "bg-zinc-100 text-zinc-500 border-zinc-200" },
];

export const PRIORITIES = [
  { value: "low", label: "Low", cls: "bg-zinc-50 text-zinc-500 border-zinc-200" },
  { value: "normal", label: "Normal", cls: "bg-sky-50 text-sky-600 border-sky-200" },
  { value: "high", label: "High", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  { value: "urgent", label: "Urgent", cls: "bg-red-50 text-red-700 border-red-200" },
];

export const PROJECT_STATUSES = [
  { value: "active", label: "Active", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { value: "on_hold", label: "On hold", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  { value: "completed", label: "Completed", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  { value: "archived", label: "Archived", cls: "bg-zinc-100 text-zinc-500 border-zinc-200" },
];

export const statusMeta = (list, value) =>
  list.find((s) => s.value === value) || list[0];

export const GANTT_STATUS_COLORS = {
  pending: "#f59e0b",
  todo: "#a1a1aa",
  in_progress: "#0284c7",
  blocked: "#dc2626",
  done: "#059669",
  cancelled: "#d4d4d8",
};

export function buildTaskTree(tasks) {
  const byParent = new Map();
  tasks.forEach((t) => {
    const key = t.parent_task_id || "__root__";
    if (!byParent.has(key)) byParent.set(key, []);
    byParent.get(key).push(t);
  });
  byParent.forEach((arr) => arr.sort((a, b) => (a.order_index ?? 0) - (b.order_index ?? 0)));
  return byParent;
}

export function flattenTree(tasks) {
  const byParent = buildTaskTree(tasks);
  const out = [];
  const walk = (parentId, depth) => {
    (byParent.get(parentId || "__root__") || []).forEach((t) => {
      out.push({ ...t, depth });
      walk(t.task_id, depth + 1);
    });
  };
  walk(null, 0);
  return out;
}
